
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { PricingComponentForm } from "@/components/PricingComponentForm";
import { Tables } from "@/integrations/supabase/types";

interface PricingTabProps {
  pricingComponents: Tables<"projects">["pricing_components"];
  setPricingComponents: (components: Tables<"projects">["pricing_components"]) => void;
}

export function PricingTab({ 
  pricingComponents, 
  setPricingComponents 
}: PricingTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Pricing Components</CardTitle>
        <CardDescription>
          Define individual components that make up the project's pricing.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <PricingComponentForm
          pricingComponents={pricingComponents}
          setPricingComponents={setPricingComponents}
        />
      </CardContent>
    </Card>
  );
}
